/** Entregador ninja de moto — ilustração vetorial própria. */
export const DeliveryRider = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 360 270" fill="none" aria-hidden="true" className={className}>
    {/* Linhas de velocidade */}
    <g stroke="#0A0A0A" strokeLinecap="round" strokeWidth="6" opacity="0.25">
      <path d="M8 118h56" />
      <path d="M0 150h44" />
      <path d="M18 182h50" />
    </g>

    {/* Sombra no chão */}
    <ellipse cx="190" cy="256" rx="138" ry="7" fill="#0A0A0A" opacity="0.15" />

    {/* Baú de entrega */}
    <rect x="34" y="76" width="84" height="70" rx="10" fill="#0A0A0A" />
    <rect x="34" y="90" width="84" height="8" fill="#FFC107" />
    <path d="M60 120a16 9 0 0 1 32 0z" fill="#FFC107" />
    <rect x="58" y="122" width="36" height="5" rx="2.5" fill="#F7F3EA" />
    <path d="M60 130h32a6 6 0 0 1-6 6H66a6 6 0 0 1-6-6z" fill="#FFC107" />

    {/* Rodas */}
    {[96, 278].map((cx) => (
      <g key={cx}>
        <circle cx={cx} cy="218" r="33" fill="#0A0A0A" />
        <circle cx={cx} cy="218" r="15" fill="#F7F3EA" />
        <circle cx={cx} cy="218" r="5" fill="#0A0A0A" />
      </g>
    ))}

    {/* Carenagem e assento */}
    <path
      d="M58 208c-2-36 26-58 62-58h58c16 0 22 12 22 26v14h44l12 18z"
      fill="#0A0A0A"
    />
    <rect x="96" y="140" width="80" height="16" rx="8" fill="#2A2A2A" />

    {/* Guidão, garfo e paralama */}
    <path d="M244 192l20-84" stroke="#0A0A0A" strokeWidth="14" strokeLinecap="round" />
    <path d="M264 112l14 104" stroke="#0A0A0A" strokeWidth="9" strokeLinecap="round" />
    <path d="M250 104l32-8" stroke="#0A0A0A" strokeWidth="8" strokeLinecap="round" />
    <path d="M243 204a35 35 0 0 1 70 0" stroke="#0A0A0A" strokeWidth="8" strokeLinecap="round" />
    <circle cx="275" cy="126" r="7" fill="#F7F3EA" />

    {/* Piloto: pernas */}
    <path d="M150 140l52 10" stroke="#0A0A0A" strokeWidth="20" strokeLinecap="round" />
    <path d="M202 150l14 38" stroke="#0A0A0A" strokeWidth="16" strokeLinecap="round" />
    <ellipse cx="224" cy="191" rx="15" ry="7" fill="#F7F3EA" />

    {/* Tronco e braço */}
    <path d="M150 138l34-50" stroke="#0A0A0A" strokeWidth="34" strokeLinecap="round" />
    <path d="M186 94l28 24" stroke="#0A0A0A" strokeWidth="14" strokeLinecap="round" />
    <path d="M214 118l36-12" stroke="#0A0A0A" strokeWidth="12" strokeLinecap="round" />
    <circle cx="252" cy="105" r="6.5" fill="#F7F3EA" />

    {/* Faixa ninja esvoaçando */}
    <path d="M170 60c-14-6-26 2-40-6" stroke="#0A0A0A" strokeWidth="6" strokeLinecap="round" />
    <path d="M170 66c-12 4-22 14-36 12" stroke="#0A0A0A" strokeWidth="6" strokeLinecap="round" />

    {/* Capacete */}
    <circle cx="190" cy="60" r="25" fill="#F7F3EA" />
    <path d="M168 54a25 25 0 0 1 44 0z" fill="#0A0A0A" opacity="0.08" />
    <path d="M196 52h18a9 9 0 0 1 0 18h-18z" fill="#0A0A0A" />
    <path d="M168 62h22" stroke="#FFC107" strokeWidth="5" strokeLinecap="round" />
  </svg>
);
